"use client";
import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";

import { SAMPLE_INTRO_1, SAMPLE_VERSE1_1, formatLyricsWithTitles } from "./data";

// Create default lyrics using sample 1
const DEFAULT_LYRICS = formatLyricsWithTitles(SAMPLE_INTRO_1, SAMPLE_VERSE1_1);

// Function to render lyrics with styled section titles
function renderLyricsWithStyling(content: string) {
  const lines = content.split("\n");
  const elements: React.ReactNode[] = [];

  lines.forEach((line, index) => {
    if (
      line.trim() === "Intro" ||
      line.trim() === "Verse 1" ||
      (line.trim().startsWith("[") && line.trim().endsWith("]"))
    ) {
      // Section titles
      elements.push(
        <div className='f-paragraph-03 -mb-8 text-overlay-darker-plus md:f-paragraph-02 md:-mb-12' key={index}>
          {line}
        </div>,
      );
    } else if (line.trim() === "") {
      // Empty lines
      elements.push(<br key={index} />);
    } else {
      // Regular lyrics lines
      elements.push(
        <div className='leading-relaxed' key={index}>
          {line}
        </div>,
      );
    }
  });

  return elements;
}

export function Lyrics({
  isLoading,
  showResult,
  content,
  embeddedInBlock = false,
}: {
  content?: string;
  embeddedInBlock?: boolean;
  isLoading: boolean;
  showResult: boolean;
}) {
  return (
    <div className='relative h-full overflow-hidden px-16 md:px-20'>
      <m.div
        animate={{
          opacity: isLoading ? [1, 0.4, 1] : 1,
        }}
        transition={{
          opacity: isLoading
            ? {
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut",
              }
            : {
                duration: 0.2,
                ease: "easeOut",
              },
        }}
      >
        <AnimatePresence mode='wait'>
          <m.div
            animate={{
              opacity: 1,
              filter: "blur(0px)",
            }}
            className='f-paragraph-04 text-overlay-darker-plus md:f-paragraph-03'
            exit={{
              opacity: 0,
              filter: "blur(3px)",
            }}
            initial={{
              opacity: 0,
              filter: "blur(3px)",
            }}
            key={content || DEFAULT_LYRICS}
            transition={{
              duration: 0.3,
              ease: "easeOut",
            }}
          >
            {renderLyricsWithStyling(content || DEFAULT_LYRICS)}
          </m.div>
        </AnimatePresence>
      </m.div>
      <div
        className='absolute bottom-0 left-0 right-0 h-80 md:h-100'
        style={{
          background: embeddedInBlock
            ? "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFFFFF 90%)"
            : "linear-gradient(180deg, rgba(245, 243, 241, 0.00) 0%, #F5F3F1 90%)",
        }}
      />
    </div>
  );
}
